<template>
  <div>
    <page-header :title="$t('dictionary.actions')" :tabs="tabs" :current-tab.sync="cloudEnv" />
    <page-body>
      <event-drawer :id="listId" enable-virtual-scroll :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
export default {
  name: 'LogIndex',
  data () {
    return {
      listId: 'LogList',
      cloudEnv: '',
      tabs: [
        { key: '', label: this.$t('common_95') },
        { key: 'normal_account', label: this.$t('system.user_log') },
        { key: 'system_account', label: this.$t('system.system_log') },
      ],
    }
  },
  computed: {
    getParams () {
      const ret = {}
      if (!this.cloudEnv) return ret
      ret.is_system_account = this.cloudEnv === 'system_account'
      return ret
    },
  },
}
</script>
